import MANGAS_JSON from "../resources/mangas.json";

const consts = {
  MANGAS: MANGAS_JSON,
  APP_NAME: "World of Scans",
  LANG: ["fr", "en", "it", "es", "jp", "kr"],
  CHAPTER_KEEPER_KEY: "savedChapterNumber/$MANGA",
  MANGA_SAVED_KEY: "savedMangas",
  MANGA_AVANCEMENT_KEY: "mangasAvancement",
  HISTORY_KEY: "history",
  SETTINGS_KEY: "settings",
  SHOW_ONLY_SAVED_KEY: "SHOW_ONLY_SAVED",
  DEVICE_ID_KEY: "DEVICE_ID",
};

export default consts;
